import { LocationVarKey } from "@swivl-mono/types";

import { IS_EQUAL, IS_NOT_EQUAL, IS_TRUE } from "../../../Components/Worksheets/Types/Worksheet.Interface";
import {
  DropdownRow,
  Indent,
  InputRow,
  MultiLineRow,
  PageHeader,
  SectionHeader,
  SwitchRow,
  TextAreaRow,
  TextRow
} from "../../../Components/Worksheets/WorksheetComponent/WorksheetComponents";
import { usePropertiesGetLocationIds } from "../../../Hooks/usePropertiesGetLocationIds";

export const PAGE_KEYS: LocationVarKey[] = [
  LocationVarKey.ShowInventory1,
  LocationVarKey.AfterNavigateShowInventory1,
  LocationVarKey.AfterNavigateShowInventory2
];

export default function WorksheetView() {
  const page = usePropertiesGetLocationIds();
  return (
    <>
      <PageHeader {...page} subheading="">
        {" "}
        Show Inventory
      </PageHeader>

      <TextAreaRow
        {...page}
        marginTop
        label=" Message 1 (Optional)"
        keyName={LocationVarKey.ShowInventory1}
        enableSwitchVar={LocationVarKey.ShowInventory1Enabled}
      />

      <SectionHeader {...page} hideIf={IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")}>
        {" "}
        After Navigate
      </SectionHeader>
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")}
        marginTop
        label=" Message 1"
        keyName={LocationVarKey.AfterNavigateShowInventory1}
      />
      <TextAreaRow
        {...page}
        hideIf={IS_NOT_EQUAL(LocationVarKey.HasAfterNavigate, "1")}
        marginTop
        label=" Message 2 (Optional)"
        keyName={LocationVarKey.AfterNavigateShowInventory2}
        enableSwitchVar={LocationVarKey.AfterNavigateShowInventory2Enabled}
      />
    </>
  );
}
